import { MobileSheet } from '@/shared/ui/MobileSheet'

import { CommentSection } from './CommentSection'
import { usePostComments } from '../model/queries'

/**
 * Bottom sheet de comentários para o carrossel do modo hub. Composição sobre
 * `MobileSheet` (design-system/MASTER.md, `stable`) — não é um novo primitivo
 * de sheet, é o único padrão de bottom sheet do projeto. Toda a lógica de
 * listar/criar comentário já existe em `CommentSection`/`usePostComments`
 * (mesmas usadas por `PostCard`) — este componente só é o container.
 */
export const FeedCommentsSheet = ({ eventSlug, postId, onClose }) => {
  const { records: comments, isLoading } = usePostComments(eventSlug, postId)

  return (
    <MobileSheet open={!!postId} onClose={onClose} ariaLabel="Comentários da publicação">
      <CommentSection
        eventSlug={eventSlug}
        postId={postId}
        comments={comments}
        isLoading={isLoading}
      />
    </MobileSheet>
  )
}
